export enum OnboardingGuideType {
  SetupGuide = 10,
}
